import { render } from "./AboutMe.vue?vue&type=template&id=21e8cc76&scoped=true"
import script from "./AboutMe.vue?vue&type=script&lang=js"
export * from "./AboutMe.vue?vue&type=script&lang=js"

import "./AboutMe.vue?vue&type=style&index=0&id=21e8cc76&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src718038542/src/nickyadvokaat-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e8cc76"]])

export default __exports__